const IS_PRODUCTION = !process.env.REACT_APP_API_BASE_URL?.includes('staging');

/**
 * Returns the appropriate product code based on the environment.
 * @param {string} stagingCode 
 * @param {string} productionCode 
 * @returns {string}
 */
const getProductCode = (stagingCode, productionCode) => {
  return IS_PRODUCTION ? (productionCode || stagingCode) : stagingCode;
};

export const B2B_PRODUCTS = [
  {
    productCode: getProductCode('DYNAMIC_VA', 'DYN-4044A9'),
    id: 'dynamic-va',
    title: 'Dynamic Virtual Account',
    description: 'Generate dynamic virtual accounts for one-time payments and automated reconciliation.'
  },
  {
    productCode: getProductCode('STATIC_VA', 'STA-1905CA'),
    id: 'static-va',
    title: 'Static Virtual Account',
    description: 'Assign permanent virtual accounts to your customers for recurring payments.'
  },
  {
    productCode: getProductCode('PAYOUT', 'PAY-84767A'),
    id: 'payout',
    title: 'Payout',
    description: 'Make individual transfers to any bank account securely and instantly.'
  },
  {
    productCode: getProductCode('PAY_WITH_WAYA', 'PAY-2A1895'),
    id: 'pay-with-waya',
    title: 'Pay with Waya',
    description: 'Enable your customers to pay directly from their WayaBank accounts.'
  },
  {
    productCode: getProductCode('BILLS_PAYMENT', 'BIL-C33EAE'),
    id: 'bills-payment',
    title: 'Bills Payment',
    description: 'Offer airtime, data, and utility bill payment services to your customers.'
  },
  {
    productCode: getProductCode('BULK_TRANSFER', 'BUL-BD5940'),
    id: 'bulk-transfer',
    title: 'Bulk Transfer',
    description: 'Process multiple transfers at once with our efficient bulk payment solution.'
  },
  {
    productCode: getProductCode('POS', 'POS'),
    id: 'pos',
    title: 'POS Terminals',
    description: 'Accept card payments at your physical locations with our reliable POS terminals.'
  }
];

